




import { Component, Mixins, Prop } from "vue-property-decorator";
import { ModelEditableMixin } from "../../system/mixins";
import { instanceOfISingleSelectableConditionallyAsynchronously, ISingleSelectableAsynchronously } from "../../system/selectors";
import { FormatReference } from "../../../domain/format";
import { IRestriction } from "../../system";

@Component({
  components: {}
})
export default class ReceptionDialogSelector extends Mixins(
  ModelEditableMixin
) {
  @Prop()
  dialog: ISingleSelectableAsynchronously<any>;

  @Prop({ default: false })
  isMultiLine: boolean;

  @Prop({ default: false })
  isClearable: boolean;

  @Prop({ default: "選択" })
  labelOfSelect: string;

  @Prop({ default: "クリア" })
  labelOfClear: string;

  @Prop()
  format: (s: any) => string;

  @Prop()
  restrictions: { [key: string]: IRestriction };

  @Prop()
  condition: any;

  get labelOfSelectedOption(): string {
    if (!this.editingSource) {
      return "";
    }
    if (this.editingSource instanceof FormatReference) {
      const format = this.editingSource as FormatReference;
      return (format.company ? format.company.name : "") + "\n" + format.name;
    }
    return !this.format
      ? this.editingSource.toString()
      : this.format(this.editingSource);
  }

  get isSelectable(): boolean {
    return !!this.dialog;
  }

  select(): void {
    if (instanceOfISingleSelectableConditionallyAsynchronously<any, any>(this.dialog)) {
      this.dialog.selectOptionConditionally(this.condition, this.editingSource, this.restrictions).then(o => {
        if (o !== undefined) {
          // undefinedの時はキャンセル.
          this.editingSource = o;
        }
      });
    } else {
      this.dialog.selectOption(this.editingSource, this.restrictions).then(o => {
        if (o !== undefined) {
          // undefinedの時はキャンセル.
          this.editingSource = o;
        }
      });
    }
  }

  clear(): void {
    this.editingSource = null;
  }
}
